<template>
  <div class="app-page">

  <!-- <el-row class="head-row-bg" justify="center">
    <el-col :span="6" class="text-align">
      <el-image class="head-logo" alt="Vue logo" :src="logoSrc" fit="fit" />
      <p class="logo-title">LIFSONG</p>
    </el-col>
    <el-col :span="18">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        router
        active-text-color="#FF5D07"
        @select="handleSelect"
      >
        <el-menu-item route="/" index="0">首页</el-menu-item>
        <el-menu-item route="/breeze" index="1">神吹系列</el-menu-item>
        <el-menu-item route="/hhb" index="2" >呵汇宝系�?/el-menu-item>
        <el-menu-item route="/about" index="3" >关于生生</el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
  <div style="height:100px;"></div> -->
  
  <router-view />
  </div>
</template>

<script setup lang="ts">
  // import commonHead from './components/CommonHead.vue'
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
